import { clearChatbotStorage } from 'core';
import useLessonStatusMessage from 'core/hooks/useLessonStatusMessage';
import { useRouter } from 'core/hooks/useRouter';
import LayoutDefault from 'core/layout/LayoutDefault';
import { LiveStatusRegion, Loading } from 'ui';
import * as auth from 'core/store/auth.duck';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

function SamlCallback({ login, t }) {
  const { token } = useParams(); //Ex: {token}&{application}
  const router = useRouter();

  useEffect(() => {
    const { query } = router;
    const { loginContext } = query;
    if (token !== 'error') {
      clearChatbotStorage();
      login({ token, loginContext });
    }
  }, []);

  const authenticatingLabel = t('Authenticating');
  // Loading nace con su texto y no se anuncia: lo dice la región, siempre montada, tras la espera.
  const statusMessage = useLessonStatusMessage({ isLoading: true, messages: { loading: authenticatingLabel }, result: 'content' });

  return (
    <LayoutDefault>
      <h1 className="visually-hidden">{authenticatingLabel}</h1>
      <LiveStatusRegion message={statusMessage} />
      <div aria-hidden="true">
        <Loading label={authenticatingLabel} />
      </div>
    </LayoutDefault>
  );
}

SamlCallback.propTypes = {
  login: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation('login')(connect(null, auth.actions)(SamlCallback));
